<template>
  <tr>
    <td
      v-if="hasViewServiceProviderPermission"
      class="has-text-centered"
      nowrap
    >
      {{ subService.service_supplier[0].code }}
      ({{ subService !== null && subService.code }})
    </td>
    <td v-if="hasViewCostPricePermission" class="color-7 text-center" nowrap>
      {{ subService.currency.currency_sign }}
      {{ subService.cost_sale }}
    </td>
    <td v-if="hasViewSalePricePermission">
      <b-tooltip label="Price calculated with risk" type="is-dark">
        <IconRisk
          v-if="
            service.prices_costs_margins.risk_price &&
            service.prices_costs_margins.risk_price === 1
          "
          class="heartIcon"
        />
      </b-tooltip>
    </td>
    <td
      v-if="hasViewSalePricePermission"
      class="has-text-weight-semibold has-text-centered"
    >
      {{ subService.currency.currency_sign }}
      {{ subService.price }}
      p.p
    </td>
    <td
      v-if="hasViewSalePricePermission"
      class="color-2 has-text-weight-semibold has-text-centered"
    >
      {{ subService.currency.currency_sign }}
      {{ subService.price_unit }}
      p.p
    </td>
    <td v-if="showQty"></td>
  </tr>
</template>

<script>
import helpers from "@/helpers";
import { PERMISSION, USER_ROLE } from "@/constants";
import { mapGetters } from "vuex";
import { serviceHelper } from "@/utils/service";

export default {
  name: "SubServiceDetail",
  props: {
    subService: Object,
    service: Object,
    showQty: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      authData: "auth/getAuthData",
    }),
    hasViewCostPricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_COST_PRICE, PERMISSION.VIEW_PRICE_SEARCHED]
      );
    },
    hasViewServiceProviderPermission() {
      return !helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
    hasViewSalePricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_SALE_PRICE, PERMISSION.VIEW_PRICE_SEARCHED]
      );
    },
  },
};
</script>

<style scoped></style>
